import { HtmlTooltip } from 'components/tooltips/HtmlTootip';
import HelpIcon from '@mui/icons-material/Help';

export const labelField = (label, tootipMessage = false, requiredField = true) => (
  <>
    {label}
    {requiredField && (
      <>
        {' '}
        <span style={{ color: '#d32f2f', fontSize: 16 }}>*</span>
      </>
    )}
    {tootipMessage && (
      <>
        {' '}
        <HtmlTooltip
          title={tootipMessage}
          placement="right"
          arrow
        >
          <HelpIcon color="primary" fontSize="inherit" />
        </HtmlTooltip>
      </>
    )}
  </>
);
